import styled from 'styled-components';
import { fontUi } from '../../../../../../theme/typography';

export const StyledTransactionsBlock = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  margin-bottom: 12px;
  padding-bottom: 4px;
  &:last-of-type {
    border-bottom: 0;
    margin-bottom: 0;
  }
`;
export const StyledTransaction = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
  &[data-type='revenue'] {
    span {
      color: ${({ theme }) => theme.success};
      &:before {
        margin-right: 0px;
        content: '+';
        ${fontUi};
        font-size: 14px;
        line-height: 26px;
        color: ${({ theme }) => theme.success};
      }
    }
  }
  &[data-type='expenses'] {
    span {
      color: ${({ theme }) => theme.danger};
    }
  }
  h4 {
    margin: 4px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    ${fontUi};
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    color: ${({ theme }) => theme.text};
  }
  span {
    ${fontUi};
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    color: ${({ theme }) => theme.text};
    flex-shrink: 0;
    margin-left: 12px;
  }
  h6 {
    margin: 4px 0;
    display: flex;
    justify-content: space-between;
    ${fontUi};
    font-size: 12px;
    line-height: 100%;
    color: ${({ theme }) => theme.textFaint};
    span {
      ${fontUi};
      font-size: 12px;
      color: ${({ theme }) => theme.textFaint};
    }
  }
`;

export const StyledDate = styled.span`
  ${fontUi};
  display: block;
  margin: 4px 0 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.textFaint};
`;
